import { backend, API_URL } from "../../config";

export const SAVE_PRODUCTS_DATA = "SAVE_PRODUCTS_DATA";
export const FETCH_PRODUCTS_DATA = "FETCH_PRODUCTS_DATA";

export const save_products_data_action = (data) => {
  return {
    type: SAVE_PRODUCTS_DATA,
    payload: data,
  };
};

export const fetch_products_data_action = (data) => {
  if (!data.length || data.length <= 100) {
    return async (dispatch) => {
      await backend
        .get(`${API_URL}products?include_inactive=true&include_nonprimary=true&no_page=1`)
        .then(({ data }) => {
          const dataMap = data.length ? data : data.results;

          const productsMap = dataMap.map((item) => ({
            ...item,
            unit_in_cart: 0,
            case_in_cart: 0,
            added_in_cart: false,
            added_through_sub: false,
          }));

          dispatch(save_products_data_action(productsMap));
        })
        .catch((error) => {
          console.log(error);
        });
    };
  }
};
